export default function Loading() {
  return <h1 className="loader">Loading.....</h1>;
}
